import { render, staticRenderFns } from "./AdsOrders.vue?vue&type=template&id=6eb0a34e&scoped=true&"
import script from "./AdsOrders.vue?vue&type=script&lang=js&"
export * from "./AdsOrders.vue?vue&type=script&lang=js&"
import style0 from "./AdsOrders.vue?vue&type=style&index=0&id=6eb0a34e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb0a34e",
  null
  
)

export default component.exports